/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UpdateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function UpdateAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/UpdateAction",
  onSubmit,
  isSubmitting
  
}) {
let editProfessionalSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_professional',
})
let editProfessionalIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_professional',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 data="edit_professional"
 onClick={editProfessionalSubmitData}
 disabled={editProfessionalIsSubmittingData}
 text="Update Professional"
/>
{children}
</React.Fragment>)
}